import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ApiError } from "@/lib/api";
import { useInviteSubcontractorViewModel } from "@/pages/dashboard/admin/useInviteSubcontractorViewModel";

export function InviteSubcontractorView() {
  const { inviteForm, setInviteForm, inviteSuccess, inviteSubcontractorMutation } = useInviteSubcontractorViewModel();
  return (
    <div className="mt-4 grid grid-cols-1 gap-4 [&>*]:min-w-0">
                <Card>
                  <CardHeader>
                    <CardTitle>Invite Subcontractor</CardTitle>
                    <CardDescription>Send an email invitation so a subcontractor can set their own password.</CardDescription>
                  </CardHeader>
                  <CardContent className="grid gap-4">
                    <form
                      className="grid gap-2"
                      onSubmit={(event) => {
                        event.preventDefault();
                        if (inviteForm.email && inviteForm.full_name) inviteSubcontractorMutation.mutate();
                      }}
                    >
                      <div className="grid grid-cols-1 gap-2 md:grid-cols-[1fr_1fr_1fr_auto]">
                        <Input value={inviteForm.full_name} onChange={(event) => setInviteForm({ ...inviteForm, full_name: event.target.value })} placeholder="Full name" />
                        <Input type="email" value={inviteForm.email} onChange={(event) => setInviteForm({ ...inviteForm, email: event.target.value })} placeholder="Email" />
                        <Input value={inviteForm.company_name} onChange={(event) => setInviteForm({ ...inviteForm, company_name: event.target.value })} placeholder="Company name" />
                        <Button type="submit" disabled={inviteSubcontractorMutation.isPending}>
                          <Plus className="size-4" />
                          Invite
                        </Button>
                      </div>
                      <div className="grid gap-1">
                        <Label htmlFor="invite-send-on">Send email on (optional)</Label>
                        <Input
                          id="invite-send-on"
                          type="date"
                          value={inviteForm.send_on}
                          onChange={(event) => setInviteForm({ ...inviteForm, send_on: event.target.value })}
                        />
                        <p className="text-xs text-muted-foreground">
                          Leave blank to send now. Pick the vendor start date or the day before so the 48-hour set-password link is still valid when they start.
                        </p>
                      </div>
                    </form>

                    {inviteSuccess && (
                      <div className="text-xs text-success">{inviteSuccess}</div>
                    )}
                    {inviteSubcontractorMutation.isError && (
                      <div className="text-xs text-destructive">
                        {inviteSubcontractorMutation.error instanceof ApiError
                          ? inviteSubcontractorMutation.error.message
                          : "Invitation failed."}
                      </div>
                    )}
                  </CardContent>
                </Card>
    </div>
  );
}
